define((require, exports, module) => {
    'use strict';

    const RPCModel = require('RPCModel');

    const CurrentUserModel = RPCModel.extend({
        className: 'MCS.CurrentUser',

        defaults: {
            /**
             * @type {string}
             */
            email: 'anonym',

            /**
             * Статус подтверждения email
             * @type {boolean}
             */
            verified: false,

            /**
             * Статус подтверждения телефона
             * @type {boolean}
             */
            verified_phone: false,

            /**
             * Роль пользователя в проекте
             * @type {Array.<string>}
             */
            roles: [],

            /**
             * @type {boolean}
             */
            hasPartnerRequest: false,

            isLoaded: false,
        },

        setCurrentUserModuleData(data, pid) {
            const {
                projects,
                email,
                // ctime,
                // domain,
                // enabled,
                // name,
                // phone,
                // uid,
                verified,
                hasPartnerRequest,
            } = data;

            // TODO: white label & other user/info data maybe

            this.set({
                email,
                verified: verified.email,
                verified_phone: verified.phone,
                roles: projects[pid],
                hasPartnerRequest,
            });
        },

        prepareSendData() {
            return {};
        },

        isAuthorized() {
            return this.get('email') !== 'anonym';
        },
    });

    module.exports = CurrentUserModel;
});
